function init() {}

export default {
	view: "loader",
	init,
};
